import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeePayrollDTO  {
    _originalTypeClassName = "zERP.BO.EmployeePayrollDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeePayrollDTO.translate = translateService;
}
this.EmployeeContractContributionDTO = [];
this.SalariesDTO = [];
this.ContributionsDTO = [];
this.DeductionDTO = [];
this.TaxesDTO = [];
this.VariablesDTO = [];
this.AdhocAdvancePaymentDTO = [];
this.Id = null;
this.DaysWorked = null;
this.DaysInsured = null;
this.AdvanceAmount = null;
this.BasicSalary = null;
this.OtherSalary = null;
this.MainSalary = null;
this.DailySalary = null;
this.HourlySalary = null;
this.TotalSalary = null;
this.EmployerContributions = null;
this.EmployeeContributions = null;
this.Tax = null;
this.PayableAmount = null;
this.EmployeeDeductions = null;
this.EmployerDeductions = null;
this.EmployeePayrollDTOKey = null;
this._key = this.EmployeePayrollDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
DaysWorked:any;
DaysInsured:any;
AdvanceAmount:any;
BasicSalary:any;
OtherSalary:any;
MainSalary:any;
DailySalary:any;
HourlySalary:any;
TotalSalary:any;
EmployerContributions:any;
EmployeeContributions:any;
Tax:any;
PayableAmount:any;
EmployeeDeductions:any;
EmployerDeductions:any;
EmployeeContractContributionDTO:any;
SalariesDTO:any;
ContributionsDTO:any;
DeductionDTO:any;
TaxesDTO:any;
VariablesDTO:any;
AdhocAdvancePaymentDTO:any;
EmployeeDTO:any;
private _EmployeePayrollDTOKey:any;
get EmployeePayrollDTOKey(): any {
    return this._EmployeePayrollDTOKey;
  }
set EmployeePayrollDTOKey(value: any) {
    this._EmployeePayrollDTOKey = value;
    this._key = value;
  }
static setEmployeeContractContributionDTO = ($this, items) => {
                if (items == null) items = [];
                if ($this.EmployeeContractContributionDTO == null) $this.EmployeeContractContributionDTO = [];

                const copyItems = Common.cloneObject(items);

                while ($this.EmployeeContractContributionDTO.length > 0) {
                    Domain.EmployeePayrollDTO.removeEmployeeContractContributionDTO($this, $this.EmployeeContractContributionDTO[0]);
                }

                Domain.EmployeePayrollDTO.addManyEmployeeContractContributionDTO($this, copyItems);
            }
static addManyEmployeeContractContributionDTO = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeePayrollDTO.addEmployeeContractContributionDTO($this, items[i]);
                }
            }
static addEmployeeContractContributionDTO = ($this, item) => {
                if ($this.EmployeeContractContributionDTO == null) $this.EmployeeContractContributionDTO = [];
                if (item == null || $this.EmployeeContractContributionDTO.indexOf(item) > -1) return;
                $this.EmployeeContractContributionDTO.push(item);
}
static addRangeEmployeeContractContributionDTO = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeePayrollDTO.addEmployeeContractContributionDTO($this, item));
            }
static removeEmployeeContractContributionDTO = ($this, item) => {
                if ($this == null || $this.EmployeeContractContributionDTO == null || $this.EmployeeContractContributionDTO.indexOf(item) === -1) return;
                var _index = $this.EmployeeContractContributionDTO.indexOf(item);
                $this.EmployeeContractContributionDTO.splice(_index, 1);
}
static clearEmployeeContractContributionDTO = ($this) => { $this.EmployeeContractContributionDTO = null; }
static setSalariesDTO = ($this, items) => {
                if (items == null) items = [];
                if ($this.SalariesDTO == null) $this.SalariesDTO = [];

                const copyItems = Common.cloneObject(items);

                while ($this.SalariesDTO.length > 0) {
                    Domain.EmployeePayrollDTO.removeSalariesDTO($this, $this.SalariesDTO[0]);
                }

                Domain.EmployeePayrollDTO.addManySalariesDTO($this, copyItems);
            }
static addManySalariesDTO = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeePayrollDTO.addSalariesDTO($this, items[i]);
                }
            }
static addSalariesDTO = ($this, item) => {
                if ($this.SalariesDTO == null) $this.SalariesDTO = [];
                if (item == null || $this.SalariesDTO.indexOf(item) > -1) return;
                $this.SalariesDTO.push(item);
}
static addRangeSalariesDTO = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeePayrollDTO.addSalariesDTO($this, item));
            }
static removeSalariesDTO = ($this, item) => {
                if ($this == null || $this.SalariesDTO == null || $this.SalariesDTO.indexOf(item) === -1) return;
                var _index = $this.SalariesDTO.indexOf(item);
                $this.SalariesDTO.splice(_index, 1);
}
static clearSalariesDTO = ($this) => { $this.SalariesDTO = null; }
static setContributionsDTO = ($this, items) => {
                if (items == null) items = [];
                if ($this.ContributionsDTO == null) $this.ContributionsDTO = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ContributionsDTO.length > 0) {
                    Domain.EmployeePayrollDTO.removeContributionsDTO($this, $this.ContributionsDTO[0]);
                }

                Domain.EmployeePayrollDTO.addManyContributionsDTO($this, copyItems);
            }
static addManyContributionsDTO = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeePayrollDTO.addContributionsDTO($this, items[i]);
                }
            }
static addContributionsDTO = ($this, item) => {
                if ($this.ContributionsDTO == null) $this.ContributionsDTO = [];
                if (item == null || $this.ContributionsDTO.indexOf(item) > -1) return;
                $this.ContributionsDTO.push(item);
}
static addRangeContributionsDTO = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeePayrollDTO.addContributionsDTO($this, item));
            }
static removeContributionsDTO = ($this, item) => {
                if ($this == null || $this.ContributionsDTO == null || $this.ContributionsDTO.indexOf(item) === -1) return;
                var _index = $this.ContributionsDTO.indexOf(item);
                $this.ContributionsDTO.splice(_index, 1);
}
static clearContributionsDTO = ($this) => { $this.ContributionsDTO = null; }
static setDeductionDTO = ($this, items) => {
                if (items == null) items = [];
                if ($this.DeductionDTO == null) $this.DeductionDTO = [];

                const copyItems = Common.cloneObject(items);

                while ($this.DeductionDTO.length > 0) {
                    Domain.EmployeePayrollDTO.removeDeductionDTO($this, $this.DeductionDTO[0]);
                }

                Domain.EmployeePayrollDTO.addManyDeductionDTO($this, copyItems);
            }
static addManyDeductionDTO = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeePayrollDTO.addDeductionDTO($this, items[i]);
                }
            }
static addDeductionDTO = ($this, item) => {
                if ($this.DeductionDTO == null) $this.DeductionDTO = [];
                if (item == null || $this.DeductionDTO.indexOf(item) > -1) return;
                $this.DeductionDTO.push(item);
}
static addRangeDeductionDTO = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeePayrollDTO.addDeductionDTO($this, item));
            }
static removeDeductionDTO = ($this, item) => {
                if ($this == null || $this.DeductionDTO == null || $this.DeductionDTO.indexOf(item) === -1) return;
                var _index = $this.DeductionDTO.indexOf(item);
                $this.DeductionDTO.splice(_index, 1);
}
static clearDeductionDTO = ($this) => { $this.DeductionDTO = null; }
static setTaxesDTO = ($this, items) => {
                if (items == null) items = [];
                if ($this.TaxesDTO == null) $this.TaxesDTO = [];

                const copyItems = Common.cloneObject(items);

                while ($this.TaxesDTO.length > 0) {
                    Domain.EmployeePayrollDTO.removeTaxesDTO($this, $this.TaxesDTO[0]);
                }

                Domain.EmployeePayrollDTO.addManyTaxesDTO($this, copyItems);
            }
static addManyTaxesDTO = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeePayrollDTO.addTaxesDTO($this, items[i]);
                }
            }
static addTaxesDTO = ($this, item) => {
                if ($this.TaxesDTO == null) $this.TaxesDTO = [];
                if (item == null || $this.TaxesDTO.indexOf(item) > -1) return;
                $this.TaxesDTO.push(item);
}
static addRangeTaxesDTO = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeePayrollDTO.addTaxesDTO($this, item));
            }
static removeTaxesDTO = ($this, item) => {
                if ($this == null || $this.TaxesDTO == null || $this.TaxesDTO.indexOf(item) === -1) return;
                var _index = $this.TaxesDTO.indexOf(item);
                $this.TaxesDTO.splice(_index, 1);
}
static clearTaxesDTO = ($this) => { $this.TaxesDTO = null; }
static setVariablesDTO = ($this, items) => {
                if (items == null) items = [];
                if ($this.VariablesDTO == null) $this.VariablesDTO = [];

                const copyItems = Common.cloneObject(items);

                while ($this.VariablesDTO.length > 0) {
                    Domain.EmployeePayrollDTO.removeVariablesDTO($this, $this.VariablesDTO[0]);
                }

                Domain.EmployeePayrollDTO.addManyVariablesDTO($this, copyItems);
            }
static addManyVariablesDTO = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeePayrollDTO.addVariablesDTO($this, items[i]);
                }
            }
static addVariablesDTO = ($this, item) => {
                if ($this.VariablesDTO == null) $this.VariablesDTO = [];
                if (item == null || $this.VariablesDTO.indexOf(item) > -1) return;
                $this.VariablesDTO.push(item);
}
static addRangeVariablesDTO = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeePayrollDTO.addVariablesDTO($this, item));
            }
static removeVariablesDTO = ($this, item) => {
                if ($this == null || $this.VariablesDTO == null || $this.VariablesDTO.indexOf(item) === -1) return;
                var _index = $this.VariablesDTO.indexOf(item);
                $this.VariablesDTO.splice(_index, 1);
}
static clearVariablesDTO = ($this) => { $this.VariablesDTO = null; }
static setAdhocAdvancePaymentDTO = ($this, items) => {
                if (items == null) items = [];
                if ($this.AdhocAdvancePaymentDTO == null) $this.AdhocAdvancePaymentDTO = [];

                const copyItems = Common.cloneObject(items);

                while ($this.AdhocAdvancePaymentDTO.length > 0) {
                    Domain.EmployeePayrollDTO.removeAdhocAdvancePaymentDTO($this, $this.AdhocAdvancePaymentDTO[0]);
                }

                Domain.EmployeePayrollDTO.addManyAdhocAdvancePaymentDTO($this, copyItems);
            }
static addManyAdhocAdvancePaymentDTO = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeePayrollDTO.addAdhocAdvancePaymentDTO($this, items[i]);
                }
            }
static addAdhocAdvancePaymentDTO = ($this, item) => {
                if ($this.AdhocAdvancePaymentDTO == null) $this.AdhocAdvancePaymentDTO = [];
                if (item == null || $this.AdhocAdvancePaymentDTO.indexOf(item) > -1) return;
                $this.AdhocAdvancePaymentDTO.push(item);
}
static addRangeAdhocAdvancePaymentDTO = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeePayrollDTO.addAdhocAdvancePaymentDTO($this, item));
            }
static removeAdhocAdvancePaymentDTO = ($this, item) => {
                if ($this == null || $this.AdhocAdvancePaymentDTO == null || $this.AdhocAdvancePaymentDTO.indexOf(item) === -1) return;
                var _index = $this.AdhocAdvancePaymentDTO.indexOf(item);
                $this.AdhocAdvancePaymentDTO.splice(_index, 1);
}
static clearAdhocAdvancePaymentDTO = ($this) => { $this.AdhocAdvancePaymentDTO = null; }
static setEmployeeDTO = ($this, value) => {
var oldValue = $this.EmployeeDTO;
$this.EmployeeDTO = value;
if (value != null) {
}
}

static Assign(ep: any): any{let epDTO = new Domain.EmployeePayrollDTO();
epDTO.Id = ep?.Id;
epDTO.DaysWorked = ep?.DaysWorked;
epDTO.DaysInsured = ep?.DaysInsured;
epDTO.AdvanceAmount = ep?.AdvanceAmount;
epDTO.BasicSalary = ep?.BasicSalary;
epDTO.OtherSalary = ep?.OtherSalary;
epDTO.MainSalary = ep?.MainSalary;
epDTO.DailySalary = ep?.DailySalary;
epDTO.HourlySalary = ep?.HourlySalary;
epDTO.TotalSalary = ep?.TotalSalary;
epDTO.EmployerContributions = ep?.EmployerContributions;
epDTO.EmployeeContributions = ep?.EmployeeContributions;
epDTO.EmployeeDeductions = ep?.EmployeeDeductions;
epDTO.Tax = ep?.Tax;
epDTO.PayableAmount = ep?.PayableAmount;
Domain.EmployeePayrollDTO.setEmployeeDTO(epDTO, Domain.EmployeeDTO.Assign(ep?.Employee));
for (let _ii = 0; _ii < (ep?.Contract?.Contributions == null ? 0 : ep?.Contract?.Contributions.length); _ii++) {let i = ep?.Contract?.Contributions[_ii];epDTO?.EmployeeContractContributionDTO?.add(Domain.EmployeeContractContributionDTO.Assign(i));}
for (let _ii = 0; _ii < (ep?.Salaries == null ? 0 : ep?.Salaries.length); _ii++) {let i = ep?.Salaries[_ii];epDTO?.SalariesDTO?.add(Domain.PayrollSalaryDetailDTO.Assign(i));}
for (let _ii = 0; _ii < (ep?.Contributions == null ? 0 : ep?.Contributions.length); _ii++) {let i = ep?.Contributions[_ii];epDTO?.ContributionsDTO?.add(Domain.PayrollContributionDetailDTO.Assign(i));}
for (let _ii = 0; _ii < (ep?.Deductions == null ? 0 : ep?.Deductions.length); _ii++) {let i = ep?.Deductions[_ii];epDTO?.DeductionDTO?.add(Domain.PayrollDeductionDetailDTO.Assign(i));}
for (let _ii = 0; _ii < (ep?.Taxes == null ? 0 : ep?.Taxes.length); _ii++) {let i = ep?.Taxes[_ii];epDTO?.TaxesDTO?.add(Domain.PayrollTaxDetailDTO.Assign(i));}
for (let _ii = 0; _ii < (ep?.Variables == null ? 0 : ep?.Variables.length); _ii++) {let i = ep?.Variables[_ii];epDTO?.VariablesDTO?.add(Domain.PayrollVariableInstanceDTO.Assign(i));}
for (let _ii = 0; _ii < (ep?.AdhocAdvancePayments == null ? 0 : ep?.AdhocAdvancePayments.length); _ii++) {let i = ep?.AdhocAdvancePayments[_ii];epDTO?.AdhocAdvancePaymentDTO?.add(Domain.AdhocAdvancePaymentDTO.Assign(i));}
return epDTO;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.EmployeePayrollDTOKey == null || $this.EmployeePayrollDTOKey == 0;
            }


}